import baseOptions from '../../../../sentry.base.config';

export const initSentry = async () => {
  const { init } = await import('@sentry/nextjs');

  init({
    ...baseOptions,
    integrations: [],
  });
};
